import React from "react";
import { createUseStyles } from "react-jss";
import { variables } from "../../variables";

const ActivitieEngineStyles = createUseStyles({
  ActivitiesEngine: {
    display: "grid",
    overflow: "hidden",
    placeContent: "center",
  },
  title: {
    display: "grid",
    textAlign: "center",
    height: "100%",
    alignItems: "end",
    padding: variables.normal_gap,
  },
});
const ActivitiesEngine = () => {
  const classes = ActivitieEngineStyles();

  return (
    <div className={classes.ActivitiesEngine}>
      <div className={classes.title}>
        <h1>Activities Engine</h1>
      </div>
    </div>
  );
};
export default ActivitiesEngine;
